export default __webpack_public_path__ + "71b1dad59fc8f794cf06873cbeabf765.png";